// extracted by mini-css-extract-plugin
export default {"wrapper":"UserProgress_wrapper__VUmb5","user-progress-title":"UserProgress_user-progress-title__logUE"};